export const RE_SIZING_PLYWOOD_DAMAGE_REQUEST = "RE_SIZING_PLYWOOD_DAMAGE_REQUEST";
export const RE_SIZING_PLYWOOD_DAMAGE_SUCCESS = "RE_SIZING_PLYWOOD_DAMAGE_SUCCESS";
export const RE_SIZING_PLYWOOD_DAMAGE_FAILED = "RE_SIZING_PLYWOOD_DAMAGE_FAILED";